import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import type { RatingsSectionProps, RatingsData } from "./types";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import ParticipationDropVoteDetailsTrigger from "./ParticipationDropVoteDetailsTrigger";
interface ParticipationDropRatingsVoterSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
}
export default function ParticipationDropRatingsVoterSection(t0) {
  const $ = _c(8);
  const {
    drop,
    ratingsData
  } = t0;
  const {
    hasRaters
  } = ratingsData;
  let t1;
  if ($[0] !== drop || $[1] !== hasRaters) {
    t1 = hasRaters && <div className="tw-flex tw-items-center -tw-space-x-1.5">{drop.top_raters.slice(0, 5).map((rater, index) => {
        if (!rater.profile.pfp) {
          return null;
        }
        const raterLabel = rater.profile.handle ?? rater.profile.primary_address;
        return <div key={rater.profile.id}><div className="tw-relative tw-transition-transform hover:tw-z-10 hover:tw-scale-110" style={{
            zIndex: drop.top_raters.length - index
          }} data-tooltip-id={`participation-rater-${rater.profile.id}`}><Link href={`/${raterLabel}`}><img src={getScaledImageUri(rater.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${raterLabel}'s avatar`} className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800 tw-object-contain tw-ring-1 tw-ring-black" /></Link></div><Tooltip id={`participation-rater-${rater.profile.id}`} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{raterLabel} • {formatNumberWithCommas(rater.rating)}{" "}{WAVE_VOTING_LABELS[drop.wave.voting_credit_type]}</Tooltip></div>;
      })}{drop.raters_count > 5 && <div className="tw-relative tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-md tw-bg-iron-900 tw-text-[10px] tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-white/10 tw-transition-transform hover:tw-scale-110">+{drop.raters_count - 5}</div>}</div>;
    $[0] = drop;
    $[1] = hasRaters;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== drop) {
    t2 = <ParticipationDropVoteDetailsTrigger drop={drop} />;
    $[3] = drop;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-leading-5">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}